export default __webpack_public_path__ + "static/media/36I-114290_-21023_0.68241af2.jpg";